export default {
  state() {
    return {
      isActionPanelOpen: false,
      isMastHeadVisible: true,
      mastheadType: 'transparent',
      playing: true,
    };
  },

  mutations: {
    toggleActionPanel(state) {
      state.isActionPanelOpen = !state.isActionPanelOpen;
    },

    hideActionPanel(state) {
      state.isActionPanelOpen = false;
    },

    showActionPanel(state) {
      state.isActionPanelOpen = true;
    },

    showMastHead(state) {
      state.isMastHeadVisible = true;
    },

    hideMastHead(state) {
      state.isMastHeadVisible = false;
    },

    changedMastheadType(state, mastheadType) {
      state.mastheadType = mastheadType;
    },

    changePlayingStatus(state, isPlaying) {
      state.playing = isPlaying;
    },
  },

  getters: {
    getActionPanelOpenStatus(state) {
      return state.isActionPanelOpen;
    },

    getMastHeadVisibleStatus(state) {
      return state.isMastHeadVisible;
    },

    getMastHeadCurrentType(state) {
      return state.mastheadType;
    },

    isPlaying(state) {
      return state.playing;
    },
  },
};
